export default __webpack_public_path__ + "logo_deva_world.png";